import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";

// Страница «не найдено»: рисуется и роутером ('*'), и Content при codeApi === 404.
export default function Abort404() {
    return <div className="abort">
        <div className="abort__code">404</div>
        <div className="abort__text">Страница не найдена</div>
        <Link className="abort__link" to="/">На главную</Link>
    </div>;
}
